import { required, requiredCheck } from 'utils/validation'
import { get } from 'lodash'

export default values => {
  const errors = {
    previousWorkAsAssessor: requiredCheck(get(values, 'previousWorkAsAssessor'))
  }

  if (get(values, 'previousWorkAsAssessor') === 'yes') {
    errors.workExperienceLength = required(get(values, 'workExperienceLength'))
  }

  return errors
}
